import { red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

// A custom theme for this app
const theme = createTheme({
    palette: {
        primary: {
            // light: will be calculated from palette.primary.main,
            // main: '#305dba',
            main: '#0f3e8a'
            //"#293042"
            // dark: will be calculated from palette.primary.main,
            // contrastText: will be calculated to contrast with palette.primary.main
        },
    },

    components: {
    }
});

export default theme;